import { useForm } from '@/common/form/FormContext'
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect } from 'react';

export const PolPeriodSelect = ({ fieldDef }) => {

  const { formValues, assignValue } = useForm();

  useEffect(() => {
    fieldDef.expr = ExprUtils.whereParams('periodicity', formValues.periodicity);

    if (fieldDef.disabled) return;

    const idField = fieldDef.field;
    const codeField = fieldDef.field.replace('Id', 'Code')

    assignValue(idField, null);
    assignValue(codeField, null);

  }, [formValues.periodicity])

  return <EntitySelect fieldDef={fieldDef} />
}